import Vue from "vue"

// 禁止输入空格
Vue.directive("disableSpace", {
  bind: function (e) {
    e.addEventListener("keydown", (event) => {
      if (event.keyCode === 32) {
        event.returnValue = false
      }
    })
  },
})
// 字符大写
Vue.directive("charUpper", {
  bind: function (e) {
    e.addEventListener("input", (event) => {
      event.target.value = event.target.value.toUpperCase()
    })
  },
})
Vue.directive("height", {
  bind: function (e) {
    const clientHeight = document.documentElement.clientHeight;
    e.style.minHeight = `${clientHeight}px`
  }
})
Vue.directive("showArrow", {
  componentUpdated: function (el, bind) {
    Vue.nextTick(() => {
      const event = new Event("scroll")
      el.parentElement.addEventListener("scroll", function (event) {
        const {
          scrollHeight,
          clientHeight,
          scrollTop
        } = event.target;
        if ((scrollTop + clientHeight) < scrollHeight) {
          el.style.display = "block"
        } else {
          el.style.display = "none";
          event.target.style.paddingBottom = "0";
        }
      })
      el.parentElement.dispatchEvent(event)
    })
  }
})



// WEBPACK FOOTER //
// ./src/utils/directive.js